/**
 * tratativa sem complemento
 */
const ADDRESS_WITHOUT_COMPLEMENT = 'ADDRESS_WITHOUT_COMPLEMENT';
/**
 * avariado
 */
const DAMAGED_PACKAGE = 'DAMAGED_PACKAGE';
/**
 * entrega prejudicada
 */
const DELAYED_DELIVERY = 'DELAYED_DELIVERY';
/**
 * entrega prejudicada com nova data
 */
const DELAYED_DELIVERY_WITH_NEW_DATE = 'DELAYED_DELIVERY_WITH_NEW_DATE';
/**
 * tratativa recusada
 */
const DELIVERY_DENIED = 'DELIVERY_DENIED';
/**
 * Mensagem padrão para quando houver um código de erro não mapeado
 */
const FALLBACK_STATUS = 'FALLBACK_STATUS';
/**
 * a caminho
 */
const GOING_TO_RECIPIENT = 'GOING_TO_RECIPIENT';
/**
 * a caminho com tempo
 */
const GOING_TO_RECIPIENT_WITH_RELATIVE_ETA =
  'GOING_TO_RECIPIENT_WITH_RELATIVE_ETA';
/**
 * na loggi sem volumetria / na loggi com volumetria
 */
const IN_LOGGI = 'IN_LOGGI';
/**
 * entregue
 */
const IN_RECIPIENT = 'IN_RECIPIENT';
/**
 * na loja / integrado
 */
const IN_SENDER = 'IN_SENDER';
/**
 * Pacote muito grande
 */
const INVALID_PACKAGE_DIMENSIONS = 'INVALID_PACKAGE_DIMENSIONS';
/**
 * extraviado
 */
const LOST_PACKAGE = 'LOST_PACKAGE';
/**
 * Pacote não encontrado
 */
const PACKAGE_NOT_FOUND = 'PACKAGE_NOT_FOUND';
/**
 * roubo ou furto
 */
const STOLEN_PACKAGE = 'STOLEN_PACKAGE';
/**
 * Pacote suspenso
 */
const SUSPENDED_PACKAGE = 'SUSPENDED_PACKAGE';
/**
 * destinatario ausente 3 vezes / tentativas excedidas
 */
const UNAVAILABLE_CANCELED = 'UNAVAILABLE_CANCELED';
/**
 * destinatario ausente / tratativa ausente
 */
const UNAVAILABLE_RECIPIENT = 'UNAVAILABLE_RECIPIENT';
/**
 * destinatario ausente com nova data / tratativa ausente com nova data
 */
const UNAVAILABLE_RECIPIENT_WITH_NEW_DATE =
  'UNAVAILABLE_RECIPIENT_WITH_NEW_DATE';
/**
 * avariado / extraviado / cancelado / roubo ou furto / aguardando devolucao
 */
const WAITING_DEVOLUTION = 'WAITING_DEVOLUTION';
/**
 * tratativa endereco errado
 */
const WRONG_ADDRESS = 'WRONG_ADDRESS';
/**
 * aguardando retirada nos correios
 */
const RECIPIENT_PICKUP = 'RECIPIENT_PICKUP';

export {
  ADDRESS_WITHOUT_COMPLEMENT,
  DAMAGED_PACKAGE,
  DELAYED_DELIVERY,
  DELAYED_DELIVERY_WITH_NEW_DATE,
  DELIVERY_DENIED,
  FALLBACK_STATUS,
  GOING_TO_RECIPIENT,
  GOING_TO_RECIPIENT_WITH_RELATIVE_ETA,
  IN_LOGGI,
  IN_RECIPIENT,
  IN_SENDER,
  INVALID_PACKAGE_DIMENSIONS,
  LOST_PACKAGE,
  PACKAGE_NOT_FOUND,
  STOLEN_PACKAGE,
  SUSPENDED_PACKAGE,
  UNAVAILABLE_CANCELED,
  UNAVAILABLE_RECIPIENT,
  UNAVAILABLE_RECIPIENT_WITH_NEW_DATE,
  WAITING_DEVOLUTION,
  WRONG_ADDRESS,
  RECIPIENT_PICKUP
};
